var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccept(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2200_17488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0454 5.72275C18.229 3.99228 16.936 2.53915 15.3071 1.51962C13.0415 0.105558 10.3579 -0.34366 7.75634 0.257902C5.15478 0.855558 2.93994 2.43368 1.52587 4.69931C0.107905 6.96493 -0.341314 9.64462 0.260249 12.2501C0.861811 14.8517 2.43994 17.0665 4.70165 18.4806C6.2954 19.4767 8.12353 20.004 9.99462 20.004H10.1157C11.979 19.9806 13.7915 19.4415 15.3618 18.4493C15.8188 18.1602 15.9517 17.5587 15.6626 17.1017C15.3735 16.6446 14.772 16.5118 14.3149 16.8009C13.0532 17.6017 11.5923 18.0352 10.0923 18.0548C8.55322 18.0743 7.04931 17.6485 5.73681 16.8321C3.91259 15.6915 2.64306 13.9102 2.16259 11.8165C1.68212 9.72275 2.0415 7.5665 3.18212 5.74228C5.53369 1.98056 10.5102 0.832121 14.272 3.18368C15.5845 4.004 16.6235 5.17196 17.2798 6.56259C17.9204 7.91806 18.1704 9.42196 18.0024 10.9063C17.9438 11.4415 18.3267 11.9259 18.8657 11.9845C19.4009 12.0431 19.8853 11.6602 19.9438 11.1212C20.1509 9.27353 19.8384 7.40634 19.0454 5.72275Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2363 6.60938L8.52539 11.3203L6.7793 9.57422C6.39648 9.19141 5.7793 9.19141 5.39648 9.57422C5.01367 9.95703 5.01367 10.5742 5.39648 10.957L7.83398 13.3945C8.02539 13.5859 8.27539 13.6797 8.52539 13.6797C8.77539 13.6797 9.02539 13.5859 9.2168 13.3945L14.6152 7.99219C14.998 7.60938 14.998 6.99219 14.6152 6.60938C14.2324 6.23047 13.6152 6.23047 13.2363 6.60938Z",
    fill: "#34A853"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2200_17488"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccept);
export default __webpack_public_path__ + "static/media/accept.fa2cd037c9214145faf556a279280be3.svg";
export { ForwardRef as ReactComponent };